import React, { ReactNode } from "react";
import { AppConfig } from "@/infrastructure/services/config";
import { IRUserBackProvider } from "@/providers/userback";
import { SentryFeedbackProvider } from "./sentry-feedback.provider";
import { UserbackFeedbackProvider } from "./userback-feedback.provider";

export interface FeedbackProviderProps {
    children?: ReactNode;
}

const appConfig = AppConfig.getInstance();

export const FeedbackProvider: React.FC<FeedbackProviderProps> = ({ children }) => {
    const currentFeedback = appConfig.CURRENT_FEEDBACK;

    if (currentFeedback === "SENTRY") {
        return (
            <SentryFeedbackProvider>
                {children}
            </SentryFeedbackProvider>
        );
    } else if (currentFeedback === "USERBACK") {
        return (
            <IRUserBackProvider>
                <UserbackFeedbackProvider>
                    {children}
                </UserbackFeedbackProvider>
            </IRUserBackProvider>
        );
    }

    return children;
};
